const curry = require('lodash/fp/curry');
const getPath = require('lodash/fp/get');
const hasPath = require('lodash/fp/has');

const pathResult = curry((path, res, obj) => {
  // if (!hasPath(path, obj)) return res.notFound();
  if (!hasPath(path, obj)) return res.value(null);
  return res.value(getPath(path, obj));
});

module.exports = pathResult;
